import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
import { BillingCartProvider } from './context/BillingCartContext';
render(<BillingCartProvider data-id="element-1194">
    <AppRouter data-id="element-1195" />
  </BillingCartProvider>, document.getElementById('root'));